/*
  ============================================================
  TELETONE BUNDLE ENGINE  (assets/ttn-bundle-engine.js)
  ============================================================
  Shared logic for the Mini Bundle section (sections/ttn-mini-bundle.liquid).

  Uses the SAME discount codes and tier thresholds as the full
  Bundle Builder (sections/bundle-builder.liquid), so a customer can
  move between pages and the cart always carries the right code:

      2     items -> BUNDLE15
      3-4   items -> BUNDLE20
      5-7   items -> BUNDLE25
      8-10  items -> BUNDLE30
      11+   items -> BUNDLE35

  IMPORTANT: if you ever change TIERS here, change the TIERS array in
  bundle-builder.liquid too. They must stay identical.

  Tier counting always uses EVERY variant in the Bundle Eligible
  collection (passed in by the section), not just the cards on screen.
  That way items added from the full builder still count on a product
  page, and vice versa.

  Safe to load more than once: the first load wins.
  ============================================================
*/
(function () {
  'use strict';
  if (window.TTNBundle) return;

  var TIERS = [
    { min: 11, pct: 35, code: 'BUNDLE35' },
    { min: 8,  pct: 30, code: 'BUNDLE30' },
    { min: 5,  pct: 25, code: 'BUNDLE25' },
    { min: 3,  pct: 20, code: 'BUNDLE20' },
    { min: 2,  pct: 15, code: 'BUNDLE15' }
  ];
  var MIN_TIER = TIERS[TIERS.length - 1];

  function getTier(n) {
    for (var i = 0; i < TIERS.length; i++) {
      if (n >= TIERS[i].min) return TIERS[i];
    }
    return null;
  }
  function getPct(n)  { var t = getTier(n); return t ? t.pct : 0; }
  function getCode(n) { var t = getTier(n); return t ? t.code : null; }
  function nextTier(n) {
    var cur = getPct(n);
    for (var i = TIERS.length - 1; i >= 0; i--) {
      if (TIERS[i].pct > cur) return TIERS[i];
    }
    return null;
  }

  /* ---------- Eligibility (union of every registered section) ---------- */
  var eligible = new Set();
  function register(ids) {
    (ids || []).forEach(function (id) {
      var n = parseInt(id, 10);
      if (!isNaN(n)) eligible.add(n);
    });
  }
  function isEligible(id) { return eligible.has(parseInt(id, 10)); }
  function countEligible(cart) {
    var n = 0;
    ((cart && cart.items) || []).forEach(function (item) {
      if (eligible.has(item.variant_id)) n += item.quantity;
    });
    return n;
  }

  /* ---------- Cart + discount plumbing ---------- */
  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart read failed');
      return r.json();
    });
  }

  // Same approach as the full builder: hit /discount/CODE without
  // following the redirect. Shopify commits the code to the session.
  function applyCode(code) {
    return new Promise(function (resolve) {
      var done = false;
      function finish() { if (!done) { done = true; resolve(); } }
      fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'manual'
      }).then(finish, finish);
      setTimeout(finish, 2500);
    });
  }

  var lastCode = null;
  function ensureTier(count) {
    if (count < 2) { lastCode = null; return Promise.resolve(null); }
    var code = getCode(count);
    if (!code || code === lastCode) return Promise.resolve(code);
    return applyCode(code).then(function () { lastCode = code; return code; });
  }

  // Uses the theme's single CartDrawer via events (never instantiate a
  // new one; that stacks listeners, see bundle-builder.liquid).
  function openDrawer() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:open'));
  }

  /* ---------- Re-prime when the cart changes in the drawer ----------
     Shopify keeps one code per cart and drops it (no fallback) when
     the cart falls below its minimum, so we apply the next code down.
     Queues one follow-up pass if changes land while a pass is running. */
  var busy = false;
  var again = false;
  function reprime(cart) {
    if (busy) { again = true; return; }
    busy = true;
    var source = cart ? Promise.resolve(cart) : getCart();
    source.then(function (c) {
      var n = countEligible(c);
      if (n < 2) { lastCode = null; return; }
      var code = getCode(n);
      if (!code || code === lastCode) return;
      document.body.classList.add('ttn-cart-repricing');
      return ensureTier(n).then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(function () {
          document.body.classList.remove('ttn-cart-repricing');
        }, 250);
      });
    }).catch(function (err) {
      console.warn('[TTN Bundle] Re-prime failed:', err);
      document.body.classList.remove('ttn-cart-repricing');
    }).then(function () {
      busy = false;
      if (again) { again = false; reprime(); }
    });
  }
  document.addEventListener('cart:updated', function (evt) {
    if (!eligible.size) return;
    reprime(evt && evt.detail && evt.detail.cart);
  });

  /* ---------- Drawer close -> resync sections ----------
     Same pattern as the full builder: stay out of the drawer's render
     cycle, catch up once it closes. Impulse sets js-drawer-open on <html>. */
  var watching = false;
  function watchDrawer() {
    if (watching) return;
    watching = true;
    var wasOpen = false;
    setInterval(function () {
      var open = document.documentElement.classList.contains('js-drawer-open');
      if (open !== wasOpen) {
        wasOpen = open;
        if (!open) {
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent('ttn-bundle:sync'));
          }, 150);
        }
      }
    }, 200);
  }

  function money(n) {
    if (n % 1 === 0) return '$' + n.toLocaleString();
    return '$' + n.toFixed(2);
  }

  /* ============================================================
     MINI BUNDLE CONTROLLER
     ============================================================ */
  function initMini(root) {
    if (!root || root.dataset.ttnInit === '1') return;
    root.dataset.ttnInit = '1';

    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-ttn-config]').textContent); } catch (e) {}
    register(cfg.eligible);

    var L = cfg.labels || {};
    var anchor = cfg.anchor ? parseInt(cfg.anchor, 10) : null;
    var lock = cfg.lock !== false && anchor !== null;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
    var onPage = new Set(cards.map(function (c) { return parseInt(c.dataset.variantId, 10); }));

    var elNudge = root.querySelector('[data-nudge]');
    var elNote  = root.querySelector('[data-note]');
    var elOld   = root.querySelector('[data-old]');
    var elNew   = root.querySelector('[data-new]');
    var elPct   = root.querySelector('[data-pct]');
    var cta     = root.querySelector('[data-cta]');
    var ctaText = root.querySelector('[data-cta-label]');

    var picked = new Set();   // chosen here, not in the cart yet
    var inCart = new Set();   // cards whose variant is already in the cart
    var cartCount = 0;        // ALL bundle-eligible items in the cart
    var adding = false;

    if (anchor !== null && !lock) picked.add(anchor);

    function selectedIds() {
      var s = new Set(picked);
      inCart.forEach(function (id) { s.add(id); });
      if (lock) s.add(anchor);
      return s;
    }
    function isFixed(id) { return (lock && id === anchor) || inCart.has(id); }

    function nudgeText(tierCount, remaining, pct) {
      if (tierCount < 2) {
        var need = 2 - tierCount;
        if (need > remaining) return '';
        return 'Add <em>' + need + ' more</em> to unlock ' + MIN_TIER.pct + '% off';
      }
      var nt = nextTier(tierCount);
      if (nt) {
        var gap = nt.min - tierCount;
        if (gap <= remaining) {
          return 'Add <em>' + gap + ' more</em> to reach ' + nt.pct + '% off';
        }
      }
      return '<em>' + pct + '% off</em> your bundle.';
    }

    function render() {
      var sel = selectedIds();
      var subtotal = 0;
      var newCount = 0;
      var newEligible = 0;
      var remaining = 0;
      var cartOnCards = 0;

      cards.forEach(function (card) {
        var id = parseInt(card.dataset.variantId, 10);
        var on = sel.has(id);
        var fixed = isFixed(id);
        card.setAttribute('aria-pressed', on ? 'true' : 'false');
        card.setAttribute('aria-disabled', fixed ? 'true' : 'false');
        card.classList.toggle('is-fixed', fixed);

        var meta = card.querySelector('[data-card-price]');
        if (meta) meta.textContent = inCart.has(id) ? L.inCart : card.dataset.priceLabel;

        if (inCart.has(id) && isEligible(id)) cartOnCards++;
        if (on) {
          subtotal += parseFloat(card.dataset.price) || 0;
          if (!inCart.has(id)) {
            newCount++;
            if (isEligible(id)) newEligible++;
          }
        } else {
          remaining++;
        }
      });

      var tierCount = cartCount + newEligible;
      var pct = getPct(tierCount);
      var final = +(subtotal * (1 - pct / 100)).toFixed(2);

      if (elOld) {
        elOld.textContent = pct ? money(subtotal) : '';
        elOld.classList.toggle('is-visible', pct > 0);
      }
      if (elNew) elNew.textContent = money(final);
      if (elPct) elPct.textContent = pct ? pct + '% off' : '';
      if (elNudge) elNudge.innerHTML = nudgeText(tierCount, remaining, pct);

      // Items from elsewhere in the bundle collection (e.g. added on the
      // full builder) still count toward the tier. Say so, so the
      // percentage is never a mystery.
      var others = cartCount - cartOnCards;
      if (elNote) {
        elNote.textContent = others > 0
          ? (others === 1 ? L.otherOne : L.otherMany.replace('{n}', others))
          : '';
        elNote.hidden = others <= 0;
      }

      if (cta && !adding) {
        ctaText.textContent = newCount === 0 ? L.view : (newCount === 1 ? L.single : L.bundle);
      }
    }

    function pulse(card) {
      card.classList.remove('is-pulse');
      void card.offsetWidth;
      card.classList.add('is-pulse');
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var id = parseInt(card.dataset.variantId, 10);
        if (isFixed(id)) return;
        if (picked.has(id)) picked.delete(id); else picked.add(id);
        pulse(card);
        render();
      });
    });

    function sync() {
      return getCart().then(function (cart) {
        inCart.clear();
        (cart.items || []).forEach(function (item) {
          if (onPage.has(item.variant_id)) inCart.add(item.variant_id);
        });
        cartCount = countEligible(cart);
        picked.forEach(function (id) { if (inCart.has(id)) picked.delete(id); });
        render();
        return ensureTier(cartCount);
      }).catch(function (err) {
        console.warn('[TTN Mini Bundle] Sync failed:', err);
      });
    }

    function addToCart() {
      var toAdd = Array.from(selectedIds()).filter(function (id) { return !inCart.has(id); });
      if (!toAdd.length) { openDrawer(); return; }

      adding = true;
      cta.disabled = true;
      ctaText.textContent = L.adding;

      getCart().then(function (cart) {
        var existing = new Set((cart.items || []).map(function (i) { return i.variant_id; }));
        var items = toAdd
          .filter(function (id) { return !existing.has(id); })
          .map(function (id) { return { id: id, quantity: 1 }; });

        var post = items.length
          ? fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: items })
            }).then(function (r) { if (!r.ok) throw new Error('Cart add failed'); })
          : Promise.resolve();

        return post.then(function () {
          // Discount must be applied AFTER the items are in the cart.
          var count = countEligible(cart) +
            items.filter(function (i) { return isEligible(i.id); }).length;
          var prime = ensureTier(count).then(function () {
            document.dispatchEvent(new CustomEvent('cart:build'));
          });
          openDrawer();
          picked.clear();
          adding = false;
          cta.disabled = false;
          return prime.then(sync);
        });
      }).catch(function (err) {
        console.error('[TTN Mini Bundle]', err);
        adding = false;
        cta.disabled = false;
        ctaText.textContent = L.retry;
        setTimeout(render, 2000);
      });
    }

    if (cta) cta.addEventListener('click', addToCart);
    document.addEventListener('ttn-bundle:sync', sync);

    render();
    sync();
    watchDrawer();
  }

  function boot() {
    document.querySelectorAll('[data-ttn-mini-bundle]').forEach(initMini);
  }

  window.TTNBundle = {
    TIERS: TIERS,
    getTier: getTier,
    getPct: getPct,
    getCode: getCode,
    register: register,
    countEligible: countEligible,
    ensureTier: ensureTier,
    getCart: getCart,
    openDrawer: openDrawer,
    initMini: initMini
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector('[data-ttn-mini-bundle]');
    if (r) initMini(r);
  });
})();
